import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { useAccessStatus } from '@/hooks/useAccessStatus'
import { WaitlistModal } from '@/components/waitlist/WaitlistModal'
import { SuspendedModal } from '@/components/waitlist/SuspendedModal'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth()
  const { isLoading: statusLoading, isWaitlisted, isSuspended } = useAccessStatus()

  // Show loading spinner while checking auth or access status
  if (loading || statusLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Render modals over the app content for access control
  return (
    <>
      {children}
      {isWaitlisted && <WaitlistModal />}
      {isSuspended && <SuspendedModal />}
    </>
  )
}
